<div class="landing" [style.--primary]="globalConfig.color">
  <main>
    <section id="inicio" class="hero section-tight">
      <div class="container hero-grid">
        <div class="hero-copy">
          <p class="eyebrow"><span class="pin-dot">●</span> {{'landing.hero.available'|traduccion}}</p>
          <h1>{{ config.title }}</h1>
          <p class="hero-subtitle">{{'landing.hero.subtitle'|traduccion}}</p>

          <div class="hero-actions">
            <a class="button button-primary" [routerLink]="language.path('locker-locations')">{{'landing.bookNow'|traduccion}} <span>→</span></a>
            <a class="text-link" [routerLink]="language.path('locker-locations')">{{'landing.viewAllLocations'|traduccion}} <span>→</span></a>
          </div>

          <div class="hero-facts" [attr.aria-label]="'landing.hero.factsLabel'|traduccion">
            <div class="fact">
              <span class="outline-icon clock-icon" aria-hidden="true"></span>
              <span>{{'landing.hero.bookingFirst'|traduccion}}<br />{{'landing.hero.bookingSecond'|traduccion}}</span>
            </div>
            <div class="fact">
              <span class="outline-icon shield-icon" aria-hidden="true"></span>
              <span>{{'landing.hero.storageFirst'|traduccion}}<br />{{'landing.hero.storageSecond'|traduccion}}</span>
            </div>
            <div class="fact">
              <span class="outline-icon calendar-icon" aria-hidden="true">29</span>
              <span>{{'landing.hero.chooseDate'|traduccion}}</span>
            </div>
          </div>
        </div>

        <div class="hero-media">
          <picture>
            <source media="(max-width: 600px)" [srcset]="config.heroImage?.imageSmall || config.heroImage?.imageMedium || config.heroImage?.imageLarge || 'assets/landing/hero-malaga.jpg'" />
            <source media="(max-width: 1024px)" [srcset]="config.heroImage?.imageMedium || config.heroImage?.imageLarge || config.heroImage?.imageSmall || 'assets/landing/hero-malaga.jpg'" />
            <img [src]="config.heroImage?.imageLarge || config.heroImage?.imageMedium || config.heroImage?.imageSmall || 'assets/landing/hero-malaga.jpg'" [alt]="config.title" />
          </picture>
        </div>
      </div>
    </section>

    <section class="benefits-strip" [attr.aria-label]="'landing.benefits.label'|traduccion">
      <div class="container benefits-grid">
        <article class="benefit">
          <div class="benefit-icon">⌖</div>
          <h3>{{'landing.benefits.locationTitle'|traduccion}}</h3>
          <p>{{'landing.benefits.locationText'|traduccion}}</p>
        </article>
        <article class="benefit">
          <div class="benefit-icon">✹</div>
          <h3>{{'landing.benefits.easyTitle'|traduccion}}</h3>
          <p>{{'landing.benefits.easyText'|traduccion}}</p>
        </article>
        <article class="benefit">
          <div class="benefit-icon">▤</div>
          <h3>{{'landing.benefits.secureTitle'|traduccion}}</h3>
          <p>{{'landing.benefits.secureText'|traduccion}}</p>
        </article>
        <article class="benefit">
          <div class="benefit-icon">⌘</div>
          <h3>{{'landing.benefits.travelTitle'|traduccion}}</h3>
          <p>{{'landing.benefits.travelText'|traduccion}}</p>
        </article>
        <article class="benefit">
          <div class="benefit-icon">◎</div>
          <h3>{{'landing.benefits.multiTitle'|traduccion}}</h3>
          <p>{{'landing.benefits.multiText'|traduccion}}</p>
        </article>
        <article class="benefit">
          <div class="benefit-icon">▢</div>
          <h3>{{'landing.benefits.supportTitle'|traduccion}}</h3>
          <p>{{'landing.benefits.supportText'|traduccion}}</p>
        </article>
      </div>
    </section>

    <app-landing-locations id="ubicaciones" [data]="locations"></app-landing-locations>

    <section id="como-funciona" class="section steps-section">
      <div class="container">
        <div class="section-heading compact-heading">
          <h2>{{'nav.howItWorks'|traduccion}}</h2>
          <p>{{'landing.steps.subtitle'|traduccion}}</p>
        </div>

        <div class="steps-grid">
          <article class="step">
            <span class="step-number">1</span>
            <h3>{{'landing.steps.bookTitle'|traduccion}}</h3>
            <p>{{'landing.steps.bookText'|traduccion}}</p>
          </article>
          <article class="step">
            <span class="step-number">2</span>
            <h3>{{'landing.steps.qrTitle'|traduccion}}</h3>
            <p>{{'landing.steps.qrText'|traduccion}}</p>
          </article>
          <article class="step">
            <span class="step-number">3</span>
            <h3>{{'landing.steps.storeTitle'|traduccion}}</h3>
            <p>{{'landing.steps.storeText'|traduccion}}</p>
          </article>
          <article class="step">
            <span class="step-number">4</span>
            <h3>{{'landing.steps.enjoyTitle'|traduccion}}</h3>
            <p>{{'landing.steps.enjoyText'|traduccion}}</p>
          </article>
        </div>
      </div>
    </section>

    <section id="tamanos" class="section sizes-section">
      <div class="container">
        <div class="section-heading compact-heading">
          <h2>{{'landing.sizes.title'|traduccion}}</h2>
          <p>{{'landing.sizes.subtitle'|traduccion}}</p>
        </div>

        <div id="reservar" class="locker-grid">
          @for (locker of config.lockers; track $index) {
            @let lockerName = lockerLiteral(locker, 'NAME');
            @let lockerDescription = lockerLiteral(locker, 'DESCRIPTION');
            <article class="locker-card">
              <div class="locker-image-wrap">
                <img [src]="lockerImage(locker)" [alt]="'landing.locker.imageAlt'|traduccion:{code: locker.code, name: lockerName || ''}" />
              </div>
              <div class="locker-body">
                <h3>{{ locker.code }}@if (lockerName) { - {{ lockerName }} }</h3>
                @if (lockerDescription) {
                  <p>{{ lockerDescription }}</p>
                }
                <p class="locker-dimensions">({{ locker.dimensions }})</p>
                <a class="button button-primary button-full" [href]="language.localizeUrl(locker.urlLink || '/locker-locations')">{{'landing.bookNow'|traduccion}}</a>
              </div>
            </article>
          }
        </div>
      </div>
    </section>

    <section class="section payment-security-section">
      <div class="container payment-security-grid">
        <div class="info-panel payment-panel">
          <h2>{{'landing.payment.title'|traduccion}}</h2>
          <p>{{'landing.payment.subtitle'|traduccion}}</p>
          <div class="payment-logos" [attr.aria-label]="'landing.payment.methodsLabel'|traduccion">
            <span class="visa">VISA</span>
            <span class="mastercard"><i></i><i></i></span>
            <span class="apple">● Pay</span>
            <span class="gpay">G Pay</span>
            <span class="card-symbol">▣</span>
          </div>
          <p class="secure-note">▣ {{'landing.payment.secure'|traduccion}}</p>
        </div>

        <div class="info-panel security-panel">
          <h2>{{'landing.security.title'|traduccion}}</h2>
          <p>{{'landing.security.subtitle'|traduccion}}</p>
          <div class="security-items">
            <span><b>◇</b> {{'landing.security.monitored'|traduccion}}</span>
            <span><b>▣</b> {{'landing.security.advanced'|traduccion}}</span>
            <span><b>◷</b> {{'landing.benefits.supportTitle'|traduccion}}</span>
            <span><b>♙</b> {{'landing.security.luggage'|traduccion}}</span>
          </div>
        </div>
      </div>
    </section>

    @if (globalConfig.visibilityControl?.reviewEnabled) {
      <app-reviews-section [reviews]="config.reviews" [average]="config.googleReviewAverage"></app-reviews-section>
    }

    @if (globalConfig.visibilityControl?.nearbyEnabled) {
      <app-nearby-section [places]="config.nearbyPlaces"></app-nearby-section>
    }

    <section id="contacto" class="contact-strip">
      <div class="container contact-strip-inner">
        <div class="contact-icon" aria-hidden="true"><img src="assets/svg/whatsapp-monochrome.svg" alt="" /></div>
        <div class="contact-copy">
          <h2>{{'landing.contact.title'|traduccion}}</h2>
          <p>{{'landing.contact.subtitle'|traduccion}}</p>
        </div>
        <a class="button button-primary contact-button" [href]="whatsappUrl" target="_blank" rel="noopener noreferrer">{{'landing.contact.cta'|traduccion}} <span aria-hidden="true">→</span></a>
      </div>
    </section>

    @if (globalConfig.visibilityControl?.faqEnabled) {
      <app-faq-section [faqs]="config.faqs"></app-faq-section>
    }
  </main>

</div>
